/* global $ */

/**
 *  capable m
 */
const data = ['capable-app', 'capable-ecommerce', 'capable-web', 'capable-data', 'capable-erp', 'capable-martech'];

const clickData = [
  'click-app',
  'click-data',
  'click-web',
  'click-martech',
  'click-erp',
];

$('#capable-ecommerce').click(() => {
  data.forEach((item) => {
    clickData.forEach((removeItem) => {
      $(`#${item}`).removeClass(removeItem);
    });
  });
});

$('#capable-app').click(() => {
  data.forEach((item) => {
    const remove = clickData.filter((clickItem) => clickItem !== 'click-app');
    $(`#${item}`).removeClass(remove);
    $(`#${item}`).toggleClass('click-app');
  });
});

$('#capable-data').click(() => {
  data.forEach((item) => {
    const remove = clickData.filter((clickItem) => clickItem !== 'click-data');
    $(`#${item}`).removeClass(remove);
    $(`#${item}`).toggleClass('click-data');
  });
});

$('#capable-web').click(() => {
  data.forEach((item) => {
    const remove = clickData.filter((clickItem) => clickItem !== 'click-web');
    $(`#${item}`).removeClass(remove);
    $(`#${item}`).toggleClass('click-web');
  });
});

$('#capable-martech').click(() => {
  data.forEach((item) => {
    const remove = clickData.filter((clickItem) => clickItem !== 'click-martech');
    $(`#${item}`).removeClass(remove);
    $(`#${item}`).toggleClass('click-martech');
  });
});

$('#capable-erp').click(() => {
  data.forEach((item) => {
    const remove = clickData.filter((clickItem) => clickItem !== 'click-erp');
    $(`#${item}`).removeClass(remove);
    $(`#${item}`).toggleClass('click-erp');
  });
});
